import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { View } from 'react-native';
import { ChallengeStatusBadge, MyChallengeBadge } from './ChallengeStatusBadge';
const ChallengeStatusBadges = ({ style, status, isMyChallenge }) => {
    return (_jsxs(View, { style: style, className: "flex-row gap-[8px]", children: [status.map(s => (_jsx(ChallengeStatusBadge, { status: s }, s))), isMyChallenge && _jsx(MyChallengeBadge, {})] }));
};
export default ChallengeStatusBadges;
